import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarDays, X } from "lucide-react";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const fmtProposed = (k, opts = { weekday: "long", day: "numeric", month: "long" }) => new Date(`${k}T12:00:00`).toLocaleDateString("fr-FR", opts);
const LABEL = { full: "Complet", closed: "Fermé" };

export default function QuoteProposedDates({ value, onChange }) {
  const [days, setDays] = useState([]);
  useEffect(() => {
    const s = new Date(); const e = new Date(); e.setDate(e.getDate() + 41);
    api.get("/quote-dates/availability", { params: { start: iso(s), end: iso(e) } }).then((r) => setDays(r.data.days || [])).catch(() => setDays([]));
  }, []);
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k].sort());

  return (
    <div className="mt-3 rounded-xl border border-slate-200 p-3" data-testid="quote-proposed-dates">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-900"><CalendarDays className="w-4 h-4 text-emerald-600" /> Dates proposées au client <span className="text-xs font-normal text-slate-400">(facultatif)</span></div>
      <p className="text-[11px] text-slate-500 mt-0.5 mb-2">Le client choisira une de ces dates en acceptant le devis. Il ne voit jamais votre agenda.</p>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2" data-testid="quote-proposed-selected">
          {value.map((k) => (
            <span key={k} className="inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-800 text-xs px-2.5 py-1">
              {fmtProposed(k)}<button type="button" onClick={() => toggle(k)} data-testid={`quote-proposed-remove-${k}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-1.5 max-h-48 overflow-y-auto">
        {days.map((d) => {
          const sel = value.includes(d.date); const off = d.status !== "available";
          return (
            <button type="button" key={d.date} disabled={off && !sel} onClick={() => toggle(d.date)} data-testid={`quote-proposed-day-${d.date}`}
              title={off ? (d.holiday || LABEL[d.status] || "Indisponible") : "Disponible"}
              className={`rounded-lg border px-1 py-1.5 text-center text-[11px] leading-tight transition-colors ${sel ? "bg-emerald-500 border-emerald-500 text-black font-semibold" : off ? "bg-slate-50 border-slate-100 text-slate-300 cursor-not-allowed" : "bg-white border-slate-200 text-slate-700 hover:border-emerald-400"}`}>
              <div className="capitalize">{fmtProposed(d.date, { weekday: "short" })}</div>
              <div className="font-semibold">{fmtProposed(d.date, { day: "numeric", month: "short" })}</div>
              {off && <div className="text-[9px]">{LABEL[d.status] || "Indispo."}</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
